import { IEnvironment } from './interfaces';

export const environment: IEnvironment = {
  production: true,
  baseApiUrl: '/api'
};
